// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"822":"402b0a21","827":"1b9da977","906":"5202e4c9","972":"655918a3"}[chunkId] + ".chunk.css";
};